//export const API_BASE = "https://localhost:7183/api";
export const API_BASE = "https://plus.apcoware.ir/api";

export async function parseJsonSafe(res: Response, fallback: any) {
    try {
        if (res.status === 204) return fallback;
        const text = await res.text();
        if (!text) return fallback;
        return JSON.parse(text);
    } catch {
        return fallback;
    }
}

// src/types/api.ts
export interface ApiTaskNote {
  id?: number;
  taskNoteId?: number;
  content: string;
  createdById?: number;
  createdAt?: string;
  updatedAt?: string;
  isDone?: boolean;
}

export interface ApiTask {
  id?: number;
  taskItemId?: number;
  title: string;
  description?: string;
  isDone?: boolean;
  createdById?: number | null;
  createdAt?: string;
  updatedAt?: string;
  notes?: ApiTaskNote[] | string[];
}

export interface ApiProject {
  id?: number;
  projectId?: number;
  title: string;
  description?: string;
  createdById?: number | null;
  createdAt?: string;
  updatedAt?: string;
  tasks?: ApiTask[];
}